// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + ({"112":"book","297":"library","913":"library-page","942":"article"}[chunkId] || chunkId) + "." + {"81":"bbe8401f","112":"21e5def9","297":"730dbada","913":"8467697f","942":"048591e6"}[chunkId] + ".js";
};